import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Funding Requirements")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Investment Required"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Pre-Money Valuation"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Minimum Investment"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fieldChanged($event))),
        name: "fundingRoundInvestmentRequired",
        class: "form-control form-control-lg form-control-solid",
        value: ""
      }),
      _createVNode(_component_ErrorMessage, {
        name: "fundingRoundInvestmentRequired",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Field, {
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fieldChanged($event))),
        type: "text",
        name: "fundingRoundPreMoneyValuation",
        class: "form-control form-control-lg form-control-solid",
        rows: "3"
      }),
      _createVNode(_component_ErrorMessage, {
        name: "fundingRoundPreMoneyValuation",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_Field, {
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fieldChanged($event))),
        type: "text",
        name: "fundingRoundMinimumInvestment",
        class: "form-control form-control-lg form-control-solid",
        rows: "3"
      }),
      _createVNode(_component_ErrorMessage, {
        name: "fundingRoundMinimumInvestment",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}